import '../shared/bootDiagnostics';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '../theme/ThemeContext';
import UserApp from './UserApp';
import '../shared/locale';
import ErrorBoundary from '../shared/components/ErrorBoundary';
import { USER_BASE_PATH } from '../shared/config/paths';
import '../index.css';
import { syncSignedInHint } from '../shared/utils/signedInHint';
import { loadAdsTag, reportSignup } from './utils/adsConversion';
import { captureAffiliate } from '../shared/utils/affiliate';

// 官网登录状态同步（已登录的旧会话也补写提示 cookie）
syncSignedInHint();
// 推广返利：?aff= 邀请码写入共享 cookie
captureAffiliate();
// Google Ads 标签(购买转化在付款成功时上报)
loadAdsTag();
// Register / Login are shared pages: they announce a new account with this event.
window.addEventListener('yc:signup', (e) => reportSignup(e.detail && e.detail.method));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <BrowserRouter basename={USER_BASE_PATH || '/'}>
                <ThemeProvider>
                    <UserApp />
                </ThemeProvider>
            </BrowserRouter>
        </ErrorBoundary>
    </React.StrictMode>
);
